const getTypedElementSelector = (elementTypeOptions) =>
  elementTypeOptions.map(({ value }) => value).join(',');

export default getTypedElementSelector;
